<template>
  <v-container fluid class="asistencia-calidad pa-3 pa-md-6">
    <v-card class="shadowCard page-card" flat>
      <div class="page-header px-4 px-md-5 pt-4 pb-3">
        <div>
          <h1 class="page-title">Toma de asistencia de calidad</h1>
          <p class="page-subtitle mb-0">
            {{ fechaHoy }}
            <span v-if="cicloNombre"> · {{ cicloNombre }}</span>
            <span v-if="grupoSeleccionado"> · {{ grupoSeleccionado.grupo }}</span>
          </p>
        </div>
        <div v-if="!esVistaRevision" class="page-actions">
          <v-btn
            outlined
            small
            class="page-actions__btn"
            :disabled="!grupoSeleccionado || cargandoLista"
            @click="abrirDialogInvitado"
          >
            <v-icon left small>mdi-account-plus</v-icon>
            Agregar alumno
          </v-btn>
          <v-btn
            depressed
            small
            color="primary"
            class="page-actions__btn"
            :loading="guardando"
            :disabled="!alumnos.length || cargandoLista"
            @click="guardar"
          >
            <v-icon left small>mdi-content-save-outline</v-icon>
            Guardar
          </v-btn>
        </div>
        <div v-else class="page-actions">
          <v-btn
            outlined
            small
            color="success"
            class="page-actions__btn"
            :loading="exportandoAgregados"
            :disabled="cargandoGrupos || cargandoResumen"
            @click="exportarAgregadosExcel"
          >
            <v-icon left small>mdi-microsoft-excel</v-icon>
            Excel agregados
          </v-btn>
        </div>
      </div>

      <v-divider></v-divider>

      <v-card-text class="px-4 px-md-5 py-4">
        <v-row dense>
          <template v-if="esVistaRevision">
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="filtroEscuela"
                :items="opcionesEscuela"
                label="Escuela"
                placeholder="Todas"
                filled
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-school"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="idPlantel"
                :items="plantelesOpciones"
                label="Sucursal"
                placeholder="Todas"
                filled
                dense
                hide-details
                clearable
                item-text="plantel"
                item-value="id_plantel"
                :loading="cargandoGrupos"
                prepend-inner-icon="mdi-office-building"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="busquedaGrupoRevision"
                label="Buscar grupo"
                placeholder="Nombre, sucursal, nivel u horario"
                filled
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="d-flex align-center flex-wrap">
              <v-chip
                class="mr-2 mb-1"
                small
                filter
                :input-value="filtroConComentarios"
                :color="filtroConComentarios ? 'deep-purple' : undefined"
                :text-color="filtroConComentarios ? 'white' : undefined"
                @click="filtroConComentarios = !filtroConComentarios"
              >
                Con comentarios
              </v-chip>
              <v-chip
                class="mb-1"
                small
                filter
                :input-value="filtroConAsistencias"
                :color="filtroConAsistencias ? 'green' : undefined"
                :text-color="filtroConAsistencias ? 'white' : undefined"
                @click="filtroConAsistencias = !filtroConAsistencias"
              >
                Con asistencias
              </v-chip>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="idPlantel"
                :items="plantelesOpciones"
                label="Sucursal"
                placeholder="Seleccionar"
                filled
                dense
                hide-details
                clearable
                item-text="plantel"
                item-value="id_plantel"
                :loading="cargandoGrupos"
                prepend-inner-icon="mdi-office-building"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="idNivel"
                :items="nivelesOpciones"
                label="Nivel"
                placeholder="Seleccionar"
                filled
                dense
                hide-details
                clearable
                item-text="nivel"
                item-value="id_nivel"
                :disabled="!idPlantel"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="horario"
                :items="horariosOpciones"
                label="Horario"
                placeholder="Seleccionar"
                filled
                dense
                hide-details
                clearable
                :disabled="!idPlantel"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="idGrupoLms"
                :items="gruposFiltrados"
                label="Grupo"
                placeholder="Seleccionar"
                filled
                dense
                hide-details
                clearable
                item-text="grupo"
                item-value="id_grupo_lms"
                :disabled="!gruposFiltrados.length"
                prepend-inner-icon="mdi-account-group"
              ></v-autocomplete>
            </v-col>
          </template>
        </v-row>

        <v-card
          v-if="idPlantel"
          outlined
          class="sucursal-card mt-4"
        >
          <v-card-title
            class="py-2 px-4 text-subtitle-2 sucursal-card__header"
            @click="comentariosExpandidos = !comentariosExpandidos"
          >
            <v-icon left small>mdi-office-building-outline</v-icon>
            Comentarios de la sucursal
            <v-chip
              v-if="comentariosSucursal.length"
              x-small
              class="ml-2"
              color="primary"
              outlined
            >
              {{ comentariosSucursal.length }}
            </v-chip>
            <v-spacer></v-spacer>
            <span class="caption grey--text font-weight-regular mr-1 d-none d-sm-inline">
              Solo hoy · {{ fechaHoy }}
            </span>
            <v-btn icon small class="ml-1" @click.stop="comentariosExpandidos = !comentariosExpandidos">
              <v-icon>{{ comentariosExpandidos ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="comentariosExpandidos">
              <v-divider></v-divider>
              <v-card-text class="px-4 py-3">
                <p class="caption grey--text mb-3">
                  Observaciones generales del plantel: limpieza, fachada, falta de material, etc.
                </p>
                <v-textarea
                  v-model="nuevoComentarioSucursal"
                  label="Nuevo comentario"
                  placeholder="Ej. Sucursal sucia en recepción, falta lámpara en fachada..."
                  filled
                  dense
                  rows="2"
                  auto-grow
                  hide-details="auto"
                ></v-textarea>
                <div class="d-flex justify-end mt-2">
                  <v-btn
                    depressed
                    small
                    color="primary"
                    class="page-actions__btn"
                    :loading="guardandoComentario"
                    :disabled="!nuevoComentarioSucursal.trim()"
                    @click="guardarComentarioSucursal"
                  >
                    <v-icon left small>mdi-comment-plus-outline</v-icon>
                    Agregar comentario
                  </v-btn>
                </div>

                <v-progress-linear
                  v-if="cargandoComentarios"
                  indeterminate
                  color="primary"
                  class="mt-3"
                  height="2"
                ></v-progress-linear>

                <div v-else-if="comentariosSucursal.length" class="mt-3">
                  <v-card
                    v-for="item in comentariosSucursal"
                    :key="item.idcomentario"
                    flat
                    class="comentario-item mb-2 pa-3"
                  >
                    <div class="text-body-2" style="white-space: pre-line">{{ item.comentario }}</div>
                    <div class="caption grey--text mt-1">
                      {{ item.nombre_usuario || 'Usuario' }}
                      <span v-if="item.fecha_creacion"> · {{ formatearHora(item.fecha_creacion) }}</span>
                    </div>
                  </v-card>
                </div>
                <div v-else class="mt-3 caption grey--text">
                  Aún no hay comentarios de esta sucursal para hoy.
                </div>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>

        <v-alert
          v-if="aviso"
          dense
          outlined
          type="info"
          class="mt-4 mb-0"
        >
          {{ aviso }}
        </v-alert>

        <div v-else-if="esVistaRevision" class="mt-4">
          <div class="d-flex align-center flex-wrap mb-3">
            <span class="caption grey--text">
              {{ gruposRevision.length }} grupos · clic para ver el detalle
            </span>
          </div>

          <v-data-table
            :headers="headersRevision"
            :items="gruposRevision"
            :items-per-page="itemsPerPageRevision"
            :footer-props="footerRevision"
            :mobile-breakpoint="0"
            dense
            class="asistencia-table grupos-revision-table"
            :loading="cargandoGrupos || cargandoResumen"
            loading-text="Cargando grupos..."
            item-key="clave_grupo"
            @click:row="abrirDetalleGrupo"
          >
            <template v-slot:item.grupo="{ item }">
              <div class="py-2">
                <div class="text-body-2 font-weight-medium">{{ item.grupo }}</div>
                <div class="caption grey--text">
                  <span v-if="item.nivel">{{ item.nivel }}</span>
                  <span v-if="item.nivel && item.horario"> · </span>
                  <span v-if="item.horario">{{ item.horario }}</span>
                </div>
              </div>
            </template>
            <template v-slot:item.escuela="{ item }">
              <v-chip
                x-small
                dark
                :color="Number(item.escuela) === 2 ? 'colorfast' : 'colorinbi'"
              >
                {{ Number(item.escuela) === 2 ? 'FAST' : 'INBI' }}
              </v-chip>
            </template>
            <template v-slot:item.cant_comentarios="{ item }">
              <v-chip
                x-small
                class="font-weight-bold"
                :color="item.cant_comentarios ? 'deep-purple' : 'grey lighten-3'"
                :text-color="item.cant_comentarios ? 'white' : 'grey darken-1'"
              >
                {{ item.cant_comentarios }}
              </v-chip>
            </template>
            <template v-slot:item.cant_alumnos="{ item }">
              <v-chip
                x-small
                class="font-weight-bold"
                :color="item.cant_alumnos ? 'indigo' : 'grey lighten-3'"
                :text-color="item.cant_alumnos ? 'white' : 'grey darken-1'"
              >
                {{ item.cant_alumnos }}
              </v-chip>
            </template>
            <template v-slot:item.cant_agregados="{ item }">
              <v-chip
                x-small
                class="font-weight-bold"
                :color="item.cant_agregados ? 'teal' : 'grey lighten-3'"
                :text-color="item.cant_agregados ? 'white' : 'grey darken-1'"
              >
                {{ item.cant_agregados }}
              </v-chip>
            </template>
            <template v-slot:item.cant_asistencias="{ item }">
              <v-chip
                x-small
                class="font-weight-bold"
                :color="item.cant_asistencias ? 'green' : 'grey lighten-3'"
                :text-color="item.cant_asistencias ? 'white' : 'grey darken-1'"
              >
                {{ item.cant_asistencias }}
              </v-chip>
            </template>
            <template v-slot:item.ver>
              <v-icon small color="grey">mdi-chevron-right</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="py-8 text-center grey--text">
                No hay grupos con esos filtros
              </div>
            </template>
          </v-data-table>
        </div>

        <div v-else-if="grupoSeleccionado" class="mt-4">
          <div class="d-flex align-center flex-wrap mb-3">
            <span class="caption grey--text mr-3">Leyenda</span>
            <v-chip x-small outlined color="success" class="mr-1">Asistió</v-chip>
            <v-chip x-small outlined color="error" class="mr-1">Falta</v-chip>
            <v-chip x-small outlined color="primary">Invitado (solo hoy)</v-chip>
            <v-spacer></v-spacer>
            <span class="caption grey--text">{{ alumnos.length }} alumnos</span>
          </div>

          <v-data-table
            v-if="!esMovil"
            :headers="headersAlumnos"
            :items="alumnos"
            :items-per-page="-1"
            hide-default-footer
            dense
            class="asistencia-table"
            :loading="cargandoLista"
            loading-text="Cargando alumnos..."
            item-key="id_usuario_lms"
          >
            <template v-slot:item.alumno="{ item }">
              <div class="py-2">
                <div class="text-body-2 font-weight-medium">{{ item.alumno }}</div>
                <div v-if="item.matricula" class="caption grey--text">{{ item.matricula }}</div>
                <v-chip
                  v-if="item.es_invitado"
                  x-small
                  outlined
                  color="primary"
                  class="mt-1"
                >
                  Invitado
                </v-chip>
              </div>
            </template>
            <template v-slot:item.asistencia="{ item }">
              <v-radio-group
                v-model="item.valor_asistencia"
                row
                dense
                hide-details
                class="mt-0 pt-0"
              >
                <v-radio color="success" :value="1" label="Asistió"></v-radio>
                <v-radio color="error" :value="2" label="Falta"></v-radio>
              </v-radio-group>
            </template>
            <template v-slot:item.nota="{ item }">
              <v-text-field
                v-model="item.nota"
                :label="item.es_invitado ? 'Nota (obligatoria)' : 'Nota'"
                :placeholder="item.es_invitado ? 'Por qué no está en la lista' : 'Opcional'"
                filled
                dense
                hide-details
                class="my-1"
              ></v-text-field>
            </template>
            <template v-slot:no-data>
              <div class="py-8 text-center grey--text">
                Este grupo no tiene alumnos para hoy
              </div>
            </template>
          </v-data-table>

          <div v-else>
            <v-card
              v-for="item in alumnos"
              :key="item.id_usuario_lms"
              outlined
              class="alumno-card mb-3"
            >
              <v-card-text class="pb-2">
                <div class="d-flex align-start">
                  <div>
                    <div class="text-subtitle-2">{{ item.alumno }}</div>
                    <div v-if="item.matricula" class="caption grey--text">{{ item.matricula }}</div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-chip v-if="item.es_invitado" x-small outlined color="primary">
                    Invitado
                  </v-chip>
                </div>
                <v-radio-group
                  v-model="item.valor_asistencia"
                  row
                  dense
                  hide-details
                  class="mt-2"
                >
                  <v-radio color="success" :value="1" label="Asistió"></v-radio>
                  <v-radio color="error" :value="2" label="Falta"></v-radio>
                </v-radio-group>
                <v-textarea
                  v-model="item.nota"
                  :label="item.es_invitado ? 'Nota (obligatoria)' : 'Nota'"
                  :placeholder="item.es_invitado ? 'Por qué no está en la lista' : 'Opcional'"
                  filled
                  dense
                  rows="2"
                  auto-grow
                  hide-details
                  class="mt-2"
                ></v-textarea>
              </v-card-text>
            </v-card>
            <div v-if="!alumnos.length && !cargandoLista" class="py-8 text-center grey--text">
              Este grupo no tiene alumnos para hoy
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDetalleGrupo" max-width="920" scrollable>
      <v-card v-if="grupoDetalle">
        <div class="d-flex align-center px-4 py-3">
          <div>
            <div class="text-subtitle-1 font-weight-medium">{{ grupoDetalle.grupo }}</div>
            <div class="caption grey--text">
              <span v-if="grupoDetalle.nivel">{{ grupoDetalle.nivel }}</span>
              <span v-if="grupoDetalle.nivel && grupoDetalle.horario"> · </span>
              <span v-if="grupoDetalle.horario">{{ grupoDetalle.horario }}</span>
              <span v-if="alumnos.length"> · {{ alumnos.length }} alumnos</span>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon small @click="cerrarDetalleGrupo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-progress-linear
            v-if="cargandoLista"
            indeterminate
            color="primary"
            class="mb-4"
            height="2"
          ></v-progress-linear>

          <div v-if="!esMovil">
            <v-data-table
              :headers="headersDetalleRevision"
              :items="alumnos"
              :items-per-page="-1"
              hide-default-footer
              dense
              class="asistencia-table"
              item-key="id_usuario_lms"
            >
              <template v-slot:item.alumno="{ item }">
                <div class="py-2">
                  <div class="text-body-2 font-weight-medium">{{ item.alumno }}</div>
                  <div v-if="item.matricula" class="caption grey--text">{{ item.matricula }}</div>
                  <v-chip
                    v-if="item.es_invitado"
                    x-small
                    outlined
                    color="primary"
                    class="mt-1"
                  >
                    Invitado
                  </v-chip>
                </div>
              </template>
              <template v-slot:item.asistencia="{ item }">
                <v-chip
                  v-if="Number(item.valor_asistencia) === 1"
                  x-small
                  outlined
                  color="success"
                >
                  Asistió
                </v-chip>
                <v-chip
                  v-else-if="Number(item.valor_asistencia) === 2"
                  x-small
                  outlined
                  color="error"
                >
                  Falta
                </v-chip>
                <span v-else class="caption grey--text">Pendiente</span>
              </template>
              <template v-slot:item.nota="{ item }">
                <span class="text-body-2" style="white-space: pre-line">{{ item.nota || '—' }}</span>
              </template>
              <template v-slot:no-data>
                <div class="py-8 text-center grey--text">
                  Este grupo no tiene alumnos para hoy
                </div>
              </template>
            </v-data-table>
          </div>

          <div v-else>
            <v-card
              v-for="item in alumnos"
              :key="item.id_usuario_lms"
              outlined
              class="alumno-card mb-3"
            >
              <v-card-text class="pb-2">
                <div class="d-flex align-start">
                  <div>
                    <div class="text-subtitle-2">{{ item.alumno }}</div>
                    <div v-if="item.matricula" class="caption grey--text">{{ item.matricula }}</div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-chip v-if="item.es_invitado" x-small outlined color="primary">
                    Invitado
                  </v-chip>
                </div>
                <div class="mt-2">
                  <v-chip
                    v-if="Number(item.valor_asistencia) === 1"
                    x-small
                    outlined
                    color="success"
                  >
                    Asistió
                  </v-chip>
                  <v-chip
                    v-else-if="Number(item.valor_asistencia) === 2"
                    x-small
                    outlined
                    color="error"
                  >
                    Falta
                  </v-chip>
                  <span v-else class="caption grey--text">Pendiente</span>
                </div>
                <div v-if="item.nota" class="text-body-2 mt-2" style="white-space: pre-line">
                  {{ item.nota }}
                </div>
              </v-card-text>
            </v-card>
            <div v-if="!alumnos.length && !cargandoLista" class="py-8 text-center grey--text">
              Este grupo no tiene alumnos para hoy
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn text small @click="cerrarDetalleGrupo">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInvitado" max-width="560" scrollable>
      <v-card>
        <div class="d-flex align-center px-4 py-3">
          <div>
            <div class="text-subtitle-1 font-weight-medium">Agregar alumno (solo hoy)</div>
            <div class="caption grey--text">No se inscribe al grupo. Aparece únicamente en esta lista de hoy.</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogInvitado = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="busquedaAlumno"
            label="Buscar por nombre o matrícula"
            placeholder="Escribe al menos 3 letras"
            filled
            dense
            hide-details
            prepend-inner-icon="mdi-magnify"
            :loading="buscandoAlumno"
            @keyup.enter="buscarAlumno"
          ></v-text-field>
          <div class="d-flex justify-end mt-2">
            <v-btn
              text
              small
              color="primary"
              :disabled="busquedaAlumno.trim().length < 3"
              :loading="buscandoAlumno"
              @click="buscarAlumno"
            >
              Buscar
            </v-btn>
          </div>

          <v-list v-if="resultadosBusqueda.length" dense class="mt-2">
            <v-list-item
              v-for="item in resultadosBusqueda"
              :key="item.id_usuario_lms"
              :disabled="item.en_grupo"
              @click="seleccionarInvitado(item)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.alumno }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.matricula || 'Sin matrícula' }}
                  <span v-if="item.en_grupo"> · Ya está en el grupo</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon v-if="invitado && invitado.id_usuario_lms === item.id_usuario_lms" color="primary">
                  mdi-check
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-alert v-else-if="busquedaHecha && !buscandoAlumno" dense text type="info" class="mt-3">
            No se encontraron alumnos con ese texto
          </v-alert>

          <template v-if="invitado">
            <v-divider class="my-4"></v-divider>
            <div class="text-body-2 font-weight-medium mb-2">{{ invitado.alumno }}</div>
            <v-radio-group v-model="invitado.valor_asistencia" row dense hide-details>
              <v-radio color="success" :value="1" label="Asistió"></v-radio>
              <v-radio color="error" :value="2" label="Falta"></v-radio>
            </v-radio-group>
            <v-textarea
              v-model="invitado.nota"
              label="Nota (obligatoria)"
              placeholder="¿Por qué no está en la lista de hoy?"
              filled
              dense
              rows="3"
              auto-grow
              class="mt-3"
              hide-details="auto"
              :rules="[v => !!String(v || '').trim() || 'La nota es obligatoria']"
            ></v-textarea>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-btn text small @click="dialogInvitado = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            color="primary"
            :disabled="!puedeAgregarInvitado"
            :loading="agregandoInvitado"
            @click="agregarInvitado"
          >
            Agregar a la lista de hoy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'TomaAsistenciaCalidad',

  components: { Alerta, carga },

  mixins: [validarErrores],

  data: function () {
    return {
      grupos: [],
      ciclo: null,
      fechaHoy: '',
      idPlantel: null,
      idNivel: null,
      horario: null,
      idGrupoLms: null,
      alumnos: [],
      cargandoGrupos: false,
      cargandoLista: false,
      guardando: false,
      dialogInvitado: false,
      busquedaAlumno: '',
      buscandoAlumno: false,
      busquedaHecha: false,
      resultadosBusqueda: [],
      invitado: null,
      agregandoInvitado: false,
      comentariosSucursal: [],
      nuevoComentarioSucursal: '',
      cargandoComentarios: false,
      guardandoComentario: false,
      comentariosExpandidos: false,
      busquedaGrupoRevision: '',
      filtroEscuela: null,
      filtroConComentarios: false,
      filtroConAsistencias: false,
      itemsPerPageRevision: 25,
      opcionesEscuela: [
        { text: 'INBI', value: 1 },
        { text: 'FAST', value: 2 },
      ],
      resumenGrupos: [],
      cargandoResumen: false,
      exportandoAgregados: false,
      dialogDetalleGrupo: false,
      grupoDetalle: null,
      headersRevision: [
        { text: 'Grupo', value: 'grupo', sortable: true },
        { text: 'Sucursal', value: 'plantel', sortable: true },
        { text: 'Escuela', value: 'escuela', sortable: true, width: '110px' },
        { text: 'Comentarios', value: 'cant_comentarios', align: 'center', width: '130px' },
        { text: 'Alumnos', value: 'cant_alumnos', align: 'center', width: '110px' },
        { text: 'Agregados', value: 'cant_agregados', align: 'center', width: '120px' },
        { text: 'Asistencias', value: 'cant_asistencias', align: 'center', width: '130px' },
        { text: '', value: 'ver', sortable: false, width: '40px', align: 'end' },
      ],
      headersDetalleRevision: [
        { text: 'Alumno', value: 'alumno', sortable: true },
        { text: 'Asistencia', value: 'asistencia', sortable: false, width: '140px' },
        { text: 'Comentario', value: 'nota', sortable: false },
      ],
      headersAlumnos: [
        { text: 'Alumno', value: 'alumno', sortable: true },
        { text: 'Asistencia', value: 'asistencia', sortable: false, width: '240px' },
        { text: 'Nota', value: 'nota', sortable: false },
      ],
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    esMovil: function () {
      return this.$vuetify.breakpoint.smAndDown
    },

    esVistaRevision: function () {
      var usuario = this.getdatosUsuarioERPERP || {}
      var id = Number(usuario.iderp)
      return [1, 334, 568].indexOf(id) !== -1
    },

    cicloNombre: function () {
      return this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : ''
    },

    idPlantelesUsuario: function () {
      var planteles = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.planteles
      if (!Array.isArray(planteles)) return []
      return planteles.map(function (p) {
        return Number(p.idplantel)
      })
    },

    gruposDeUsuario: function () {
      var grupos = (this.grupos || []).filter(function (g) {
        return Number(g.deleted) === 0
      })
      if (this.esVistaRevision) return grupos
      var ids = this.idPlantelesUsuario
      if (!ids.length) return []
      return grupos.filter(function (g) {
        return ids.indexOf(Number(g.id_plantel)) !== -1
      })
    },

    plantelesOpciones: function () {
      var vistos = {}
      var lista = []
      var escuelaFiltro = this.esVistaRevision ? this.filtroEscuela : null
      this.gruposDeUsuario.forEach(function (g) {
        if (escuelaFiltro && Number(g.escuela) !== Number(escuelaFiltro)) return
        var id = Number(g.id_plantel)
        if (!vistos[id]) {
          vistos[id] = true
          lista.push({ id_plantel: id, plantel: g.plantel })
        }
      })
      lista.sort(function (a, b) {
        return String(a.plantel).localeCompare(String(b.plantel))
      })
      return lista
    },

    gruposPorSucursal: function () {
      if (!this.idPlantel) return []
      var id = Number(this.idPlantel)
      return this.gruposDeUsuario.filter(function (g) {
        return Number(g.id_plantel) === id
      })
    },

    nivelesOpciones: function () {
      var vistos = {}
      var lista = []
      this.gruposPorSucursal.forEach(function (g) {
        var id = g.id_nivel
        if (id == null || vistos[String(id)]) return
        vistos[String(id)] = true
        lista.push({
          id_nivel: id,
          nivel: g.nivel || (Number(id) ? ('NIVEL ' + id) : 'Sin nivel'),
        })
      })
      lista.sort(function (a, b) {
        return Number(a.id_nivel) - Number(b.id_nivel)
      })
      return lista
    },

    gruposPorNivel: function () {
      var grupos = this.gruposPorSucursal
      if (this.idNivel == null || this.idNivel === '') return grupos
      var id = this.idNivel
      return grupos.filter(function (g) {
        return String(g.id_nivel) === String(id)
      })
    },

    horariosOpciones: function () {
      var vistos = {}
      var lista = []
      this.gruposPorNivel.forEach(function (g) {
        var h = g.horario || ''
        if (!h || vistos[h]) return
        vistos[h] = true
        lista.push(h)
      })
      lista.sort()
      return lista
    },

    gruposFiltrados: function () {
      var grupos = this.gruposPorNivel
      if (this.horario) {
        var horario = this.horario
        grupos = grupos.filter(function (g) {
          return g.horario === horario
        })
      }
      return grupos
    },

    grupoSeleccionado: function () {
      var id = this.idGrupoLms
      if (!id) return null
      return this.gruposFiltrados.find(function (g) {
        return Number(g.id_grupo_lms) === Number(id)
      }) || this.gruposDeUsuario.find(function (g) {
        return Number(g.id_grupo_lms) === Number(id)
      }) || null
    },

    gruposRevision: function () {
      var resumenByKey = {}
      ;(this.resumenGrupos || []).forEach(function (r) {
        resumenByKey[String(r.escuela) + '-' + String(r.id_grupo_lms)] = r
      })
      var texto = String(this.busquedaGrupoRevision || '').trim().toLowerCase()
      var idPlantel = this.idPlantel
      var escuelaFiltro = this.filtroEscuela
      var conComentarios = this.filtroConComentarios
      var conAsistencias = this.filtroConAsistencias
      var lista = this.gruposDeUsuario.map(function (g) {
        var r = resumenByKey[String(g.escuela || 1) + '-' + String(g.id_grupo_lms)] || {}
        return Object.assign({}, g, {
          clave_grupo: String(g.escuela || 1) + '-' + String(g.id_grupo_lms),
          cant_comentarios: Number(r.cant_comentarios) || 0,
          cant_alumnos: Number(g.cant_alumnos) || 0,
          cant_agregados: Number(r.cant_agregados) || 0,
          cant_asistencias: Number(r.cant_asistencias) || 0,
        })
      })
      if (escuelaFiltro) {
        lista = lista.filter(function (g) {
          return Number(g.escuela) === Number(escuelaFiltro)
        })
      }
      if (idPlantel) {
        lista = lista.filter(function (g) {
          return Number(g.id_plantel) === Number(idPlantel)
        })
      }
      if (conComentarios) {
        lista = lista.filter(function (g) {
          return g.cant_comentarios > 0
        })
      }
      if (conAsistencias) {
        lista = lista.filter(function (g) {
          return g.cant_asistencias > 0
        })
      }
      if (texto) {
        lista = lista.filter(function (g) {
          var blob = [g.grupo, g.plantel, g.nivel, g.horario].join(' ').toLowerCase()
          return blob.indexOf(texto) !== -1
        })
      }
      return lista
    },

    footerRevision: function () {
      return {
        'items-per-page-options': [10, 25, 50, 100, -1],
        'items-per-page-text': 'Grupos por página',
      }
    },

    aviso: function () {
      if (this.cargandoGrupos) return ''
      if (!this.esVistaRevision && !this.idPlantelesUsuario.length) {
        return 'Tu usuario no tiene sucursales asignadas. Pide a sistemas que te asignen planteles.'
      }
      if (!this.gruposDeUsuario.length && this.grupos.length) {
        return 'Hay grupos en el ciclo, pero ninguno coincide con tus sucursales asignadas.'
      }
      if (!this.grupos.length) {
        return 'No hay grupos en el ciclo actual.'
      }
      if (this.esVistaRevision) return ''
      if (!this.idPlantel) {
        return 'Selecciona una sucursal para ver comentarios y filtrar grupos.'
      }
      if (!this.grupoSeleccionado) {
        return 'Filtra por nivel, horario y grupo para tomar asistencia.'
      }
      return ''
    },

    puedeAgregarInvitado: function () {
      return !!(
        this.invitado &&
        this.invitado.id_usuario_lms &&
        String(this.invitado.nota || '').trim()
      )
    },
  },

  watch: {
    idPlantel: function (val) {
      this.idNivel = null
      this.horario = null
      this.idGrupoLms = null
      this.alumnos = []
      this.nuevoComentarioSucursal = ''
      this.comentariosSucursal = []
      this.comentariosExpandidos = false
      if (!this.esVistaRevision) this.busquedaGrupoRevision = ''
      this.cerrarDetalleGrupo()
      if (val) this.cargarComentariosSucursal()
    },
    filtroEscuela: function () {
      if (!this.idPlantel) return
      var id = Number(this.idPlantel)
      var existe = this.plantelesOpciones.some(function (p) {
        return Number(p.id_plantel) === id
      })
      if (!existe) this.idPlantel = null
    },
    idNivel: function () {
      this.horario = null
      this.idGrupoLms = null
      this.alumnos = []
    },
    horario: function () {
      this.idGrupoLms = null
      this.alumnos = []
    },
    idGrupoLms: function (val) {
      if (this.esVistaRevision) return
      if (val) this.cargarLista()
      else this.alumnos = []
    },
    dialogDetalleGrupo: function (val) {
      if (!val) {
        this.grupoDetalle = null
        if (this.esVistaRevision) this.alumnos = []
      }
    },
  },

  created: function () {
    this.cargarGrupos()
  },

  methods: {
    mensajeError: function (error, fallback) {
      if (error && error.body && error.body.message) return error.body.message
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      return fallback
    },

    cargarGrupos: function () {
      var self = this
      this.cargandoGrupos = true
      this.cargar = true
      this.$http
        .post('calidad.asistencia.grupos', {})
        .then(function (response) {
          self.grupos = (response.data && response.data.respuesta) || []
          self.ciclo = (response.data && response.data.ciclo) || null
          self.fechaHoy = (response.data && response.data.fecha) || self.fechaLocal()
          if (self.plantelesOpciones.length === 1 && !self.esVistaRevision) {
            self.idPlantel = self.plantelesOpciones[0].id_plantel
          }
          if (self.esVistaRevision) self.cargarResumen()
        })
        .catch(function (error) {
          self.validarError(self.mensajeError(error, 'No se pudieron cargar los grupos'))
        })
        .finally(function () {
          self.cargandoGrupos = false
          self.cargar = false
        })
    },

    fechaLocal: function () {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    },

    exportarAgregadosExcel: function () {
      var self = this
      if (this.exportandoAgregados) return
      this.exportandoAgregados = true
      this.$http
        .post('calidad.asistencia.invitados', {
          escuela: this.filtroEscuela || null,
          id_plantel: this.idPlantel || null,
        })
        .then(function (response) {
          var invitados = (response.data && response.data.invitados) || []
          if (!invitados.length) {
            self.validarError('No hay alumnos agregados para exportar con esos filtros')
            return
          }
          var filas = invitados.map(function (a) {
            return {
              Fecha: a.fecha || self.fechaHoy,
              Escuela: a.escuela || '',
              Sucursal: a.sucursal || '',
              Grupo: a.grupo || '',
              Horario: a.horario || '',
              Nivel: a.nivel || '',
              Matricula: a.matricula || '',
              Nombre: a.nombre || '',
              Comentario: a.comentario || '',
              Asistencia: a.asistencia || '',
            }
          })
          var headers = [
            'Fecha',
            'Escuela',
            'Sucursal',
            'Grupo',
            'Horario',
            'Nivel',
            'Matricula',
            'Nombre',
            'Comentario',
            'Asistencia',
          ]
          var workbook = XLSX.utils.book_new()
          var sheet = XLSX.utils.json_to_sheet(filas, { header: headers })
          sheet['!cols'] = [
            { wch: 12 },
            { wch: 8 },
            { wch: 18 },
            { wch: 48 },
            { wch: 16 },
            { wch: 12 },
            { wch: 14 },
            { wch: 36 },
            { wch: 40 },
            { wch: 12 },
          ]
          XLSX.utils.book_append_sheet(workbook, sheet, 'Agregados')
          var fecha = (response.data && response.data.fecha) || self.fechaHoy || self.fechaLocal()
          var nombre = ('alumnos_agregados_' + fecha).replace(/[\\/:*?"<>|]/g, '_')
          XLSX.writeFile(workbook, nombre + '.xlsx')
          self.validarSuccess('Se exportaron ' + filas.length + ' alumnos agregados')
        })
        .catch(function (error) {
          self.validarError(self.mensajeError(error, 'No se pudo generar el Excel'))
        })
        .finally(function () {
          self.exportandoAgregados = false
        })
    },

    nombrePlantelSeleccionado: function () {
      var id = Number(this.idPlantel)
      var found = this.plantelesOpciones.find(function (p) {
        return Number(p.id_plantel) === id
      })
      return found ? found.plantel : ''
    },

    formatearHora: function (fecha) {
      if (!fecha) return ''
      var d = new Date(fecha)
      if (isNaN(d.getTime())) return String(fecha)
      var hh = String(d.getHours()).padStart(2, '0')
      var mm = String(d.getMinutes()).padStart(2, '0')
      return hh + ':' + mm
    },

    cargarComentariosSucursal: function () {
      var self = this
      if (!this.idPlantel) return
      this.cargandoComentarios = true
      this.$http
        .post('calidad.asistencia.sucursal.comentarios', {
          id_plantel: this.idPlantel,
        })
        .then(function (response) {
          self.comentariosSucursal = (response.data && response.data.comentarios) || []
          if (response.data && response.data.fecha) self.fechaHoy = response.data.fecha
        })
        .catch(function (error) {
          self.comentariosSucursal = []
          self.validarError(self.mensajeError(error, 'No se pudieron cargar los comentarios'))
        })
        .finally(function () {
          self.cargandoComentarios = false
        })
    },

    guardarComentarioSucursal: function () {
      var self = this
      var texto = String(this.nuevoComentarioSucursal || '').trim()
      if (!this.idPlantel || !texto) return

      var usuario = this.getdatosUsuarioERPERP || {}
      this.guardandoComentario = true
      this.$http
        .post('calidad.asistencia.sucursal.comentarios.add', {
          id_plantel: this.idPlantel,
          plantel: this.nombrePlantelSeleccionado(),
          comentario: texto,
          nombre_usuario: usuario.nombre_completo || usuario.nombre || null,
        })
        .then(function (response) {
          self.nuevoComentarioSucursal = ''
          self.comentariosSucursal = (response.data && response.data.comentarios) || []
          self.validarSuccess((response.data && response.data.message) || 'Comentario guardado')
        })
        .catch(function (error) {
          self.validarError(self.mensajeError(error, 'No se pudo guardar el comentario'))
        })
        .finally(function () {
          self.guardandoComentario = false
        })
    },

    cargarLista: function (grupoParam) {
      var self = this
      var grupo = grupoParam || this.grupoDetalle || this.grupoSeleccionado
      if (!grupo) return
      this.cargandoLista = true
      if (!this.esVistaRevision) this.cargar = true
      this.$http
        .post('calidad.asistencia.lista', {
          id_grupo_lms: grupo.id_grupo_lms,
          id_grupo_erp: grupo.iderp,
          escuela: grupo.escuela || grupo.id_unidad_negocio,
        })
        .then(function (response) {
          var lista = (response.data && response.data.alumnos) || []
          self.alumnos = lista.map(function (a) {
            return Object.assign({}, a, {
              valor_asistencia: Number(a.valor_asistencia) || 0,
              es_invitado: Number(a.es_invitado) ? 1 : 0,
              nota: a.nota || '',
            })
          })
          if (response.data && response.data.fecha) self.fechaHoy = response.data.fecha
        })
        .catch(function (error) {
          self.alumnos = []
          self.validarError(self.mensajeError(error, 'No se pudo cargar la lista'))
        })
        .finally(function () {
          self.cargandoLista = false
          self.cargar = false
        })
    },

    cargarResumen: function () {
      var self = this
      if (!this.esVistaRevision) return
      this.cargandoResumen = true
      this.$http
        .post('calidad.asistencia.resumen', {})
        .then(function (response) {
          self.resumenGrupos = (response.data && response.data.resumen) || []
          if (response.data && response.data.fecha) self.fechaHoy = response.data.fecha
        })
        .catch(function (error) {
          self.resumenGrupos = []
          self.validarError(self.mensajeError(error, 'No se pudo cargar el resumen de grupos'))
        })
        .finally(function () {
          self.cargandoResumen = false
        })
    },

    abrirDetalleGrupo: function (item) {
      var grupo = null
      if (item && item.id_grupo_lms) grupo = item
      else if (item && item.item && item.item.id_grupo_lms) grupo = item.item
      if (!grupo) return
      this.grupoDetalle = grupo
      this.dialogDetalleGrupo = true
      this.cargarLista(grupo)
    },

    cerrarDetalleGrupo: function () {
      this.dialogDetalleGrupo = false
      this.grupoDetalle = null
      this.alumnos = []
    },

    guardar: function () {
      var self = this
      var grupo = this.grupoSeleccionado
      if (!grupo) return

      var invitadosSinNota = this.alumnos.filter(function (a) {
        return a.es_invitado && !String(a.nota || '').trim()
      })
      if (invitadosSinNota.length) {
        return this.validarError('Agrega una nota a cada alumno invitado (por qué no está en la lista)')
      }

      this.guardando = true
      this.cargar = true
      this.$http
        .post('calidad.asistencia.guardar', {
          id_grupo_lms: grupo.id_grupo_lms,
          id_grupo_erp: grupo.iderp,
          escuela: grupo.escuela || grupo.id_unidad_negocio,
          alumnos: this.alumnos,
        })
        .then(function (response) {
          self.validarSuccess((response.data && response.data.message) || 'Asistencia de calidad guardada')
          self.cargarLista()
        })
        .catch(function (error) {
          self.validarError(self.mensajeError(error, 'No se pudo guardar'))
        })
        .finally(function () {
          self.guardando = false
          self.cargar = false
        })
    },

    abrirDialogInvitado: function () {
      this.dialogInvitado = true
      this.busquedaAlumno = ''
      this.resultadosBusqueda = []
      this.busquedaHecha = false
      this.invitado = null
    },

    buscarAlumno: function () {
      var self = this
      var grupo = this.grupoSeleccionado
      var texto = String(this.busquedaAlumno || '').trim()
      if (!grupo || texto.length < 3) return
      this.buscandoAlumno = true
      this.busquedaHecha = true
      this.$http
        .post('calidad.asistencia.buscar.alumno', {
          texto: texto,
          escuela: grupo.escuela || grupo.id_unidad_negocio,
          id_grupo_lms: grupo.id_grupo_lms,
        })
        .then(function (response) {
          self.resultadosBusqueda = response.data || []
        })
        .catch(function (error) {
          self.resultadosBusqueda = []
          self.validarError(self.mensajeError(error, 'No se pudo buscar'))
        })
        .finally(function () {
          self.buscandoAlumno = false
        })
    },

    seleccionarInvitado: function (item) {
      if (item.en_grupo) return
      var yaEnLista = this.alumnos.some(function (a) {
        return Number(a.id_usuario_lms) === Number(item.id_usuario_lms)
      })
      if (yaEnLista) {
        return this.validarError('Ese alumno ya está en la lista de hoy')
      }
      this.invitado = {
        id_usuario_lms: item.id_usuario_lms,
        id_alumno_erp: item.id_alumno_erp,
        matricula: item.matricula,
        alumno: item.alumno,
        valor_asistencia: 1,
        nota: '',
        es_invitado: 1,
      }
    },

    agregarInvitado: function () {
      var self = this
      var grupo = this.grupoSeleccionado
      if (!this.puedeAgregarInvitado || !grupo) return
      this.agregandoInvitado = true
      this.$http
        .post('calidad.asistencia.invitado', {
          id_grupo_lms: grupo.id_grupo_lms,
          id_grupo_erp: grupo.iderp,
          escuela: grupo.escuela || grupo.id_unidad_negocio,
          id_usuario_lms: this.invitado.id_usuario_lms,
          id_alumno_erp: this.invitado.id_alumno_erp,
          nota: this.invitado.nota,
          valor_asistencia: this.invitado.valor_asistencia,
        })
        .then(function () {
          self.dialogInvitado = false
          self.validarSuccess('Alumno agregado solo por hoy')
          self.cargarLista()
        })
        .catch(function (error) {
          self.validarError(self.mensajeError(error, 'No se pudo agregar el alumno'))
        })
        .finally(function () {
          self.agregandoInvitado = false
        })
    },
  },
}
</script>

<style scoped>
.asistencia-calidad {
  max-width: 1400px;
}

.page-card {
  border-radius: 12px;
  overflow: hidden;
}

.page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.page-title {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
}

.page-subtitle {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 4px;
}

.page-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.page-actions__btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
}

.asistencia-table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.asistencia-table >>> thead th {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  background: #fafafa !important;
}

.alumno-card {
  border-radius: 10px;
}

.sucursal-card {
  border-radius: 10px;
}

.sucursal-card__header {
  cursor: pointer;
  user-select: none;
}

.comentario-item {
  background: #f7f8fa;
  border-radius: 8px;
}

.grupos-revision-table >>> tbody tr {
  cursor: pointer;
}

.grupos-revision-table >>> tbody tr:hover {
  background: #f5f7fa !important;
}

.grupos-revision-table >>> td {
  vertical-align: middle !important;
}

.grupo-revision-card {
  cursor: pointer;
}

@media (max-width: 600px) {
  .page-actions {
    width: 100%;
  }

  .page-actions__btn {
    flex: 1 1 auto;
  }
}
</style>
